import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import Icon from "./bloc.svg";

export default class LSAddBlocCont extends Plugin {
    init() {
        // on récupère l'objet editor de l'éditeur
        const editor = this.editor;
        // sur la propriété ui l'éditeur on invoque la compenentFactory pour créer un bouton
        editor.ui.componentFactory.add("ls_bloc_cont", (locale) => {
            // 'ls_block' est le nom du bouton à déclarer dans la barre d'outils de l'éditeur
            // on crée un bouton
            const button = new ButtonView(locale);
            // on défini le label du bouton
            button.set({
                label: "Intégrer un bloc modifiable",
                icon: Icon,
                tooltip: true,
            });
            this.listenTo(button, "execute", () => {
                const event = new CustomEvent("ckAddBlock", {
                    detail: {
                        editor: editor,
                        type: "block_reusable",
                    },
                });
                document.dispatchEvent(event);
            });
            // on retourne le bouton
            return button;
        });
    }
}
